import { defineComponent as _defineComponent } from 'vue'
import { UpcomingReleaseLabel } from '@/@types/graphql-types';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { formattedReleaseDate } from '@/helpers/date-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { BuyBoxFilterOptions } from '@/stores/user.store';
import { SnowplowContext } from '@/helpers/tracking/providers';
import ListUpcomingOffer from '@/features/buybox/components/list/ListUpcomingOffer.vue';
import { computed } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';
import type { UpcomingReleaseBuybox } from '@/features/buybox/types/types.ts';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListUpcoming',
  props: {
    upcomingRelease: null,
    title: null,
    isTitleInWatchlist: { type: Boolean },
    isPromotedBuyBox: { type: Boolean },
    filter: null,
    additionalContexts: null
  },
  emits: ["onNotifyMe"],
  setup(__props: any) {

const props = __props as {
	upcomingRelease: UpcomingReleaseBuybox;
	title: TitleDetail;
	isTitleInWatchlist?: boolean;
	isPromotedBuyBox?: boolean;
	filter: BuyBoxFilterOptions;
	additionalContexts: SnowplowContext[];
};

const { language, country } = useLanguageStore();

const { t, tc } = useI18n();





const isTheatrical = computed(() => props.upcomingRelease.offer.releaseType === 'THEATRICAL');
const upcomingOfferLabel = computed(() => props.upcomingRelease.offer.label);

const releaseDateFormatted = computed(() => {
	const formattedDate = formattedReleaseDate(
		props.upcomingRelease.offer.releaseDate,
		upcomingOfferLabel.value,
		language.value,
		'short',
		country.value,
		true
	).heading;

	if (isSeason.value) {
		const year = new Date(props.upcomingRelease.offer.releaseDate).getFullYear();
		return `${formattedDate} ${year}`;
	}

	return formattedDate;
});

const providerClearName = computed(() => {
	return props.upcomingRelease.offer.package?.packageId === 350
		? 'Apple TV'
		: props.upcomingRelease.offer.package?.clearName;
});
const isSeason = computed(() => {
	return [
		UpcomingReleaseLabel.Spring,
		UpcomingReleaseLabel.Summer,
		UpcomingReleaseLabel.Autumn,
		UpcomingReleaseLabel.Winter,
	].includes(upcomingOfferLabel.value);
});
const isDate = computed(() => upcomingOfferLabel.value === UpcomingReleaseLabel.Date);
const isMonth = computed(() => upcomingOfferLabel.value === UpcomingReleaseLabel.Month);
const isYear = computed(() => upcomingOfferLabel.value === UpcomingReleaseLabel.Year);
const isTBA = computed(() => upcomingOfferLabel.value === UpcomingReleaseLabel.ToBeAnnounced);
const isTomorrow = computed(() => upcomingOfferLabel.value === UpcomingReleaseLabel.Tomorrow);
const isToday = computed(() => upcomingOfferLabel.value === UpcomingReleaseLabel.Today);

const showProviderName = computed(() => {
	if (!providerClearName.value) return false;
	return !props.upcomingRelease.isInGroup || props.upcomingRelease.allSameProviders;
});

const upcomingBanner = computed(() => {
	if (
		isTheatrical.value
	) {
		if (isDate.value) return t('WEBAPP_COMING_TO_THEATERS_ON_DATE', { date: releaseDateFormatted.value });
		if (isMonth.value) return t('WEBAPP_COMING_TO_THEATERS_MONTH', { month: releaseDateFormatted.value });
		if (isSeason.value) return t('WEBAPP_COMING_TO_THEATERS_SEASON', { season: releaseDateFormatted.value });
		if (isYear.value) return t('WEBAPP_COMING_TO_THEATERS_YEAR', { year: releaseDateFormatted.value });
		if (isToday.value) return t('WEBAPP_COMING_TO_THEATRES_TODAY');
		if (isTomorrow.value) return t('WEBAPP_COMING_TO_THEATRES_TOMORROW');
		if (isTBA.value) return tc('WEBAPP_COMING_TO_THEATERS_TBA');
	}

	// prettier-ignore
	else if (showProviderName.value) {
		// prettier-ignore
		if (isDate.value) return t('WEBAPP_COMING_TO_PROVIDERS_ON_DATE', { provider: providerClearName.value, date: releaseDateFormatted.value });
		// prettier-ignore
		if (isMonth.value) return t('WEBAPP_COMING_TO_PROVIDER_MONTH', { provider: providerClearName.value, month: releaseDateFormatted.value });
		// prettier-ignore
		if (isSeason.value) return t('WEBAPP_COMING_TO_PROVIDER_SEASON', { provider: providerClearName.value, season: releaseDateFormatted.value });
		// prettier-ignore
		if (isYear.value) return t('WEBAPP_COMING_TO_PROVIDER_YEAR', { provider: providerClearName.value, year: releaseDateFormatted.value });
		if (isToday.value) return t('WEBAPP_COMING_TO_PROVIDER_TODAY', { provider: providerClearName.value });
		if (isTomorrow.value) return t('WEBAPP_COMING_TO_PROVIDER_TOMORROW', { provider: providerClearName.value });
		if (isTBA.value) return t('WEBAPP_COMING_TO_PROVIDER_TBA', { provider: providerClearName.value });
	}

	if (isDate.value) return t('WEBAPP_COMING_TO_STREAMING_ON_DATE', { date: releaseDateFormatted.value });
	if (isMonth.value) return t('WEBAPP_COMING_TO_STREAMING_MONTH', { month: releaseDateFormatted.value });
	if (isSeason.value) return t('WEBAPP_COMING_TO_STREAMING_SEASON', { season: releaseDateFormatted.value });
	if (isYear.value) return t('WEBAPP_COMING_TO_STREAMING_YEAR', { year: releaseDateFormatted.value });
	if (isToday.value) return t('WEBAPP_COMING_TO_STREAMING_TODAY', { day: releaseDateFormatted.value });
	if (isTomorrow.value) return t('WEBAPP_COMING_TO_STREAMING_TOMORROW', { day: releaseDateFormatted.value });
	if (isTBA.value) return tc('WEBAPP_COMING_TO_STREAMING_TBA');

	return t('WEBAPP_COMING_TO_STREAMING_ON_DATE', { date: releaseDateFormatted.value });
});

return { __sfc: true,language, country, t, tc, props, isTheatrical, upcomingOfferLabel, releaseDateFormatted, providerClearName, isSeason, isDate, isMonth, isYear, isTBA, isTomorrow, isToday, showProviderName, upcomingBanner, ListUpcomingOffer }
}

})